module.exports = __webpack_public_path__ + "img/selected7-min.5a53c635.png";